const couponListInfo = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/coupon/list-info.vue")), "coupon");
const couponListManage = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/coupon/list-manage.vue")), "coupon");
const couponListUse = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/coupon/list-use.vue")), "coupon");


export default
[
    {
        path: "/coupon/list-info",
        name: "coupon-list-info",
        component: couponListInfo,
        meta: {
            title: "优惠券",
            pageName: "GJ_优惠券信息列表"
        }
    },
    {
        path: "/coupon/list-manage",
        name: "coupon-list-manage",
        component: couponListManage,
        meta: {
            title: "优惠券管理",
            pageName: "GJ_优惠券管理列表"
        }
    },
    {
        path: "/coupon/list-use",
        name: "coupon-list-use",
        component: couponListUse,
        meta: {
            title: "优惠券管理",
            pageName: "GJ_优惠券使用列表"
        }
    },
]